module.exports = __webpack_public_path__ + "static/media/di_eco.411ed739.pdf";